module.exports = __webpack_public_path__ + "static/media/Students.0e5f70a9.png";